@if (svg() !== undefined) {
  <div [innerHtml]="svg()" [ngStyle]="iconStyle()" [title]="title()"></div>
} @else {
  <div [ngClass]="iconClass()" [ngStyle]="iconStyle()" [title]="title()">{{ iconName() }}</div>
}
